(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  if (customElements.get('upup-photo-viewer')) return;
  class PhotoViewer extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.photos = [...this.querySelectorAll('img[data-full-src]')];
      if (!this.photos.length) return;
      this.photos.forEach((photo, index) => {
        photo.setAttribute('role', 'button');
        photo.setAttribute('tabindex', '0');
        photo.setAttribute('aria-label', `Open photo ${index + 1} of ${this.photos.length}`);
        photo.addEventListener('click', () => this.open(index, photo), { signal });
        photo.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); this.open(index, photo);
          }
        }, { signal });
      });
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'upup-photo-dialog';
      this.dialog.setAttribute('aria-label', 'Product photo viewer');
      this.dialog.innerHTML = `<div class="upup-photo-bar"><span data-photo-count aria-live="polite"></span><div><button type="button" data-zoom-out aria-label="Zoom out">−</button><button type="button" data-zoom-in aria-label="Zoom in">+</button><button type="button" data-photo-close aria-label="Close photo viewer" autofocus>×</button></div></div><div class="upup-photo-stage"><img alt="" draggable="false"><p data-photo-error hidden>Unable to load photo. Please close and try again.</p></div><button class="upup-photo-prev" type="button" aria-label="Previous photo">←</button><button class="upup-photo-next" type="button" aria-label="Next photo">→</button>`;
      document.body.append(this.dialog);
      this.stage = this.dialog.querySelector('.upup-photo-stage');
      this.image = this.stage.querySelector('img');
      this.points = new Map();
      this.dialog.querySelector('[data-photo-close]').addEventListener('click', () => this.close(), { signal });
      this.dialog.querySelector('.upup-photo-prev').addEventListener('click', () => this.show(this.index - 1), { signal });
      this.dialog.querySelector('.upup-photo-next').addEventListener('click', () => this.show(this.index + 1), { signal });
      this.dialog.querySelector('[data-zoom-in]').addEventListener('click', () => this.zoom(this.scale * 1.5), { signal });
      this.dialog.querySelector('[data-zoom-out]').addEventListener('click', () => this.zoom(this.scale / 1.5), { signal });
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); }, { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      this.image.addEventListener('load', () => this.fit(), { signal });
      this.image.addEventListener('error', () => {
        this.image.style.visibility = 'hidden';
        this.dialog.querySelector('[data-photo-error]').hidden = false;
      }, { signal });
      this.stage.addEventListener('pointerdown', event => this.start(event), { signal });
      this.stage.addEventListener('pointermove', event => this.move(event), { signal });
      this.stage.addEventListener('pointerup', event => this.end(event), { signal });
      this.stage.addEventListener('pointercancel', event => this.end(event, true), { signal });
      this.stage.addEventListener('dblclick', event => { if (event.pointerType !== 'touch') this.zoom(this.scale > 1 ? 1 : 2.5); }, { signal });
      this.stage.addEventListener('wheel', event => {
        event.preventDefault(); this.zoom(this.scale * (event.deltaY < 0 ? 1.15 : 1 / 1.15));
      }, { passive: false, signal });
      window.addEventListener('resize', () => { if (this.dialog.open) this.fit(); }, { signal });
      window.addEventListener('pagehide', () => this.close(), { signal });
    }
    open(index, trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger;
      this.scroll = { x: window.scrollX, y: window.scrollY };
      this.saved = [document.documentElement, document.body].map(element => ({ element, props: ['overflow', 'position', 'top', 'left', 'width', 'scroll-behavior'].map(name => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]) }));
      try {
        this.dialog.showModal();
        document.documentElement.style.setProperty('overflow', 'hidden', 'important');
        Object.entries({ overflow: 'hidden', position: 'fixed', top: `-${this.scroll.y}px`, left: `-${this.scroll.x}px`, width: '100%' }).forEach(([name, value]) => document.body.style.setProperty(name, value, 'important'));
        this.show(index);
      } catch (error) { this.close(); throw error; }
    }
    show(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      this.scale = 1; this.x = 0; this.y = 0; this.points.clear(); this.gesture = null; this.lastTap = 0;
      const source = this.photos[this.index];
      this.dialog.querySelector('[data-photo-count]').textContent = `${this.index + 1} / ${this.photos.length}`;
      this.dialog.querySelectorAll('.upup-photo-prev,.upup-photo-next').forEach(button => button.hidden = this.photos.length < 2);
      this.dialog.querySelector('[data-photo-error]').hidden = true;
      this.image.style.visibility = 'hidden';
      this.image.alt = source.alt;
      this.image.src = source.dataset.fullSrc;
      if (this.image.complete && this.image.naturalWidth) this.fit();
    }
    fit() {
      if (!this.dialog.open || !this.image.naturalWidth) return;
      const ratio = Math.min(this.stage.clientWidth / this.image.naturalWidth, this.stage.clientHeight / this.image.naturalHeight, 1);
      this.w = this.image.naturalWidth * ratio; this.h = this.image.naturalHeight * ratio;
      this.image.style.width = `${this.w}px`; this.image.style.height = `${this.h}px`;
      this.image.style.visibility = 'visible'; this.paint();
    }
    paint() {
      const bx = Math.max(0, (this.w * this.scale - this.stage.clientWidth) / 2);
      const by = Math.max(0, (this.h * this.scale - this.stage.clientHeight) / 2);
      this.x = Math.max(-bx, Math.min(bx, this.x)); this.y = Math.max(-by, Math.min(by, this.y));
      this.image.style.transform = `translate(calc(-50% + ${this.x}px), calc(-50% + ${this.y}px)) scale(${this.scale})`;
      this.stage.style.cursor = this.scale > 1 ? 'grab' : 'zoom-in';
    }
    zoom(scale) { this.scale = Math.max(1, Math.min(6, scale)); this.paint(); }
    start(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.stage.setPointerCapture(event.pointerId);
      this.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (this.points.size === 1) {
        this.gesture = { x: event.clientX, y: event.clientY, ox: this.x, oy: this.y, time: Date.now(), pinched: false };
      } else if (this.points.size === 2) {
        const [a, b] = [...this.points.values()];
        const rect = this.stage.getBoundingClientRect();
        this.gesture = { pinched: true, distance: Math.hypot(a.x - b.x, a.y - b.y), scale: this.scale, cx: (a.x + b.x) / 2 - rect.left - rect.width / 2, cy: (a.y + b.y) / 2 - rect.top - rect.height / 2, ox: this.x, oy: this.y };
      }
    }
    move(event) {
      if (!this.points.has(event.pointerId) || !this.gesture) return;
      this.points.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const g = this.gesture;
      if (this.points.size === 2 && g.distance) {
        const [a, b] = [...this.points.values()];
        const rect = this.stage.getBoundingClientRect();
        this.scale = Math.max(1, Math.min(6, g.scale * Math.hypot(a.x - b.x, a.y - b.y) / Math.max(1, g.distance)));
        const factor = this.scale / g.scale;
        this.x = (a.x + b.x) / 2 - rect.left - rect.width / 2 - (g.cx - g.ox) * factor;
        this.y = (a.y + b.y) / 2 - rect.top - rect.height / 2 - (g.cy - g.oy) * factor;
        this.paint();
      } else if (this.points.size === 1 && this.scale > 1) {
        this.x = g.ox + event.clientX - g.x; this.y = g.oy + event.clientY - g.y; this.paint();
      }
    }
    end(event, cancelled = false) {
      if (!this.points.has(event.pointerId)) return;
      const g = this.gesture;
      this.points.delete(event.pointerId);
      if (this.points.size === 1) {
        const p = [...this.points.values()][0];
        this.gesture = { x: p.x, y: p.y, ox: this.x, oy: this.y, pinched: true };
        return;
      }
      if (this.points.size || !g) return;
      this.gesture = null;
      if (cancelled || g.pinched) return;
      const dx = event.clientX - g.x, dy = event.clientY - g.y;
      if (this.scale === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) this.show(this.index + (dx < 0 ? 1 : -1));
      else if (event.pointerType === 'touch' && Math.hypot(dx, dy) < 10 && Date.now() - g.time < 300) {
        if (Date.now() - this.lastTap < 320) { this.zoom(this.scale > 1 ? 1 : 2.5); this.lastTap = 0; }
        else this.lastTap = Date.now();
      }
    }
    close() { if (this.dialog?.open) this.dialog.close(); this.restore(); }
    restore() {
      if (!this.saved) return;
      const saved = this.saved; this.saved = null;
      saved.forEach(({ element, props }) => props.forEach(([name, value, priority]) => value ? element.style.setProperty(name, value, priority) : element.style.removeProperty(name)));
      const root = document.documentElement;
      const behavior = [root.style.getPropertyValue('scroll-behavior'), root.style.getPropertyPriority('scroll-behavior')];
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      this.trigger?.focus({ preventScroll: true });
      window.scrollTo(this.scroll.x, this.scroll.y);
      behavior[0] ? root.style.setProperty('scroll-behavior', ...behavior) : root.style.removeProperty('scroll-behavior');
      this.points.clear(); this.gesture = null;
    }
    disconnectedCallback() {
      this.close(); this.abort?.abort(); this.dialog?.remove(); this.abort = null;
    }
  }
  customElements.define('upup-photo-viewer', PhotoViewer);
})();


  } catch(e) { console.error(e); }
})();
})();
